import { FACILITY_WORKSPACE_COOKIE } from '../types/authenticationContext.types';

export const getTenantFacilityCookie = (tenantId: string) => {
	return `${FACILITY_WORKSPACE_COOKIE}.${tenantId}`;
};
